// extracted by mini-css-extract-plugin
export var wordContainer = "_ky-0";